// Angular
import { Component, Input, OnInit } from '@angular/core';
import { AuthService } from '../../../../../provider/auth/auth.service';
import { UserService } from '../../../../../provider/user.service';
import { Router } from '@angular/router';
import { UserModel } from '../../../../models/user.model';
import { MatDialog } from '@angular/material';
import { ChangeHotelPopup } from '../../../../component/popup/change-hotel/change-hotel.popup';
import { Subscription } from 'rxjs';

@Component({
  selector: 'kt-user-profile',
  templateUrl: './user-profile.component.html',
})
export class UserProfileComponent implements OnInit {
  @Input() badge = true;
  subs: Subscription[] = [];

  constructor(
    private authService: AuthService,
    public userService: UserService,
    private router: Router,
    private dialog: MatDialog
  ) {
  }

  ngOnInit(): void {
    this.userService.getMe();
    // this.user$ = this.store.pipe(select(currentUser));
  }

  logout() {
    this.authService.logOff();
    this.router.navigateByUrl('/auth').then();
  }

  changeHotel(_user: UserModel) {
    const hotels = _user.hotel_names.split(',');
    if (hotels.length > 1) {
      const poisDialog = this.dialog.open(ChangeHotelPopup, { width: '1000px', height: '700px', data: hotels });
      const sub = poisDialog.afterClosed().subscribe(result => {
        console.log(result);
      });
      this.subs.push(sub);
    }
  }

  getHotelLength(hotel_names: string): boolean {
    const hotels = hotel_names.split(',');
    return hotels.length > 1;
  }


}
